// MOVE TO SERVER

export const getXPForLevel = (level = 1) => {
    return (50 * level ** 2) + (850 * level) - 900;
}

export const getLevelFromXP = (xp = 0) => {

    const a = 50;
    const b = 850;
    const c = -900 - xp;

    const discriminant = b ** 2 - 4 * a * c;

    const plus = (-b + Math.sqrt(discriminant)) / (2 * a);
    const minus = (-b - Math.sqrt(discriminant)) / (2 * a);

    return Math.floor(Math.max(plus, minus));
}

export const getLevelPercentFromXP = (xp = 0) => {
    const currentLevel = getLevelFromXP(xp);
    const currentLevelStartXP = getXPForLevel(currentLevel);
    const nextLevelStartXP = getXPForLevel(currentLevel + 1);

    return (xp - currentLevelStartXP) / (nextLevelStartXP - currentLevelStartXP) * 100;
}

export const getPercentageOfLevelFromXP = (level = 1, xp = 0) => {
    const currentLevelStartXP = getXPForLevel(level);
    const nextLevelStartXP = getXPForLevel(level + 1);
    if (xp < currentLevelStartXP) return 0;
    if (xp >= nextLevelStartXP) return 100;
    return getLevelPercentFromXP(xp);
}